import "@melloware/coloris/dist/coloris.css";
import "@eastdesire/jscolor";
import {BookNowQuestionnaire} from './book_now_services'
import { Common } from '../../utils/common';
import {confirmPlus} from '../common/custom_confirm';

export class BookNowSettings extends HTMLElement {
  constructor() {
    super();

    this.not_setup = true;
  }

  async connectedCallback() {
    this.domain_id = document.querySelector('#object_id').value;

    let res = await fetch(`/admin/domains/${this.domain_id}/service_titan_settings`, {
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
      method: 'GET',
    });

    if (!res.ok) {
      throw new Error(res.statusText);
    }


    let data = await res.json()
    this.not_setup = !data.tenant_id && !data.client_id && !data.client_secret;

    console.log({'not_setup': this.not_setup})

    let nav_color = data.branding_config.find(
      (config) => config.item_name == BookNowSettings.BRANDING_NAV_COLOR
    );
    let nav_bg_color = data.branding_config.find(
      (config) => config.item_name == BookNowSettings.BRANDING_NAV_BG_COLOR
    );

    this.innerHTML = `
        <style>
          book-now-settings h4 {
            margin-top: 20px;
          }
        </style>
        <div id="book-now-container" class="row col-lg-8 no-gutters">
          <h2>Book Now</h2>
          <div class="errors-container col-sm-12"></div>
          <div class="row">
            <div class="panel panel-default">
              <div class="panel-body">
                <div class="row">
                  <div class="col-xs-12">
                    <button class="btn btn-link pull-right" id="edit-credentials" type="button">Alter Values</button>
                  </div>
                  <div class="col-sm-4">
                    <div>
                      <label>Tenant ID</label>
                    </div>
                    <input
                      name="tenant-id"
                      autocomplete="do-not-autofill"
                      class="form-control book-now-credentials"
                      type="text"
                      id="book-now-tenant-id"
                      value="${data.tenant_id}"
                    />
                  </div>
                  <div class="col-sm-4">
                    <div>
                      <label>Client ID</label>
                    </div>
                    <input
                      name="client-id"
                      autocomplete="do-not-autofill"
                      class="form-control book-now-credentials"
                      type="text"
                      id="book-now-client-id"
                      value="${data.client_id}"
                    />
                  </div>
                  <div class="col-sm-4">
                    <div>
                      <label>Client Secret</label>
                    </div>
                    <input
                      name="client-secret"
                      autocomplete="do-not-autofill"
                      class="form-control book-now-credentials"
                      type="password"
                      id="book-now-client-secret"
                      value="${data.client_secret}"
                    />
                  </div>
                  <div class="col-xs-12 submit-buttons-row">
                    <button class="btn btn-default" id="cancel-book-now-credentials" type="button">Cancel</button>
                    <button class="btn btn-primary" id="save-book-now-credentials" type="button">Save</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          ${
            this.not_setup
              ? ''
              : `<div class="row">
            <div class="col-sm-12">
              <h4 class="pull-left col-sm-4 no-gutters">Book Now Enabled</h4>
               <label class="switch col-sm-4" style="margin-top:10px;">
                <input type="checkbox" class="form-control switch" id="book-now-enabled" ${
                  data.enabled ? 'checked' : ''
                }>
                <span></span>
              </label>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <h4 class="pull-left col-sm-4 no-gutters">Book Now Browser Button Enabled </h4>
               <label class="switch col-sm-4" style="margin-top:10px;">
                <input type="checkbox" class="form-control switch" id="book-now-browser-button-enabled" 
                ${data.book_now_browser_button_enabled ? 'checked' : ''}
                ${data.enabled ? '' : 'disabled'}
                >
                <span></span>
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              <h4>CRM Campaign</h4>
              <select is="book-now-campaigns-select" name="book-now-campaign-id" class="form-control" id="book-now-campaign-id" domain_id="${
                this.domain_id
              }" data-selected="${data.campaign_id}"></select>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <h4 class="pull-left col-sm-4 no-gutters">Add Arrival Time Slot</h4>
               <label class="switch col-sm-4" style="margin-top:10px;">
                <input type="checkbox" class="form-control switch" id="book-now-arrival-window-enabled" ${
                  data.arrival_window_enabled == '1' ? 'checked' : ''
                }>
                <span></span>
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <h4>Manage Services</h4>
              <span class="col-sm-12 no-gutters pull-left">Setup all your services and job types.</span>
              <button class="btn btn-outline-primary pull-right" id="book-now-open-manager">Manage</button>
            </div>
          </div> 
          <div class="row">
            <div class="col-sm-12">
              <h4>Service Zones</h4>
              <span class="col-sm-12 no-gutters pull-left">Setup your service areas.</span>
              <button class="btn btn-outline-primary pull-right" id="book-now-service-zones">Manage</button>
            </div>
          </div> 
          <div class="row">
            <div class="col-sm-12">
              <h4>Service Hours</h4>
              <span class="col-sm-12 no-gutters pull-left">Setup your hours and appointment times.</span>
              <button class="btn btn-outline-primary pull-right" id="book-now-service-hours">Manage</button>
            </div>
          </div> 
          <div class="row">
            <div class="col-sm-12">
              <h4>Confirmation Message</h4>
              <span class="col-sm-12 no-gutters pull-left">This message will be displayed once a consumer has made a booking.</span>
              <textarea id="book_now_confirmation" class="form-control" maxlength="1000">${
                data.book_now_confirmation_message ? data.book_now_confirmation_message : ''
              }</textarea>
            </div>
          </div> 
          <div class="row">
            <div class="col-sm-12">
              <h4>Manage Branding</h4>
              <span class="col-sm-12 no-gutters">Setup branding for the BookNow modal.</span>
            </div>
            <div class="col-sm-6">
              <label class="pull-left">Nav Background Color</label>
              <input type="text" id="book-now-nav-bg-color" class="form-control" value="${
                nav_bg_color ? nav_bg_color.item_value : '#000000'
              }">
            </div>
            <div class="col-sm-6">
              <label class="pull-left">Nav Text Color</label>
              <input type="text" id="book-now-nav-color" class="form-control" value="${
                nav_color ? nav_color.item_value : '#FFFFFF'
              }">
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12" style="margin-top: 20px">                                                                      
              <button class="btn btn-primary pull-right" id="save-book-now-settings">Save</button>
            </div>
          </div>
        </div>
          `
          }
      `;

    const cancelCredentialsButton = /** @type {HTMLButtonElement} */ (
      this.querySelector('#cancel-book-now-credentials')
    );
    const saveCredentialsButton = /** @type {HTMLButtonElement} */ (
      this.querySelector('#save-book-now-credentials')
    );
    const editCredentialsButton = /** @type {HTMLButtonElement} */ (
      this.querySelector('#edit-credentials')
    );

    if (!this.not_setup) {
      this.querySelectorAll('.book-now-credentials').forEach((input) => {
        input.setAttribute('readonly', 'true');
      });

      cancelCredentialsButton.style.display = 'none';
      saveCredentialsButton.style.display = 'none';

      this.navBgColor = new JSColor('#book-now-nav-bg-color');
      this.navColor = new JSColor('#book-now-nav-color');

      let bookNowQuestionnaire = new BookNowQuestionnaire(
        function () {
          bookNowQuestionnaire.classList.add('hidden');
          this.querySelector('#book-now-container').classList.remove('hidden');
        }.bind(this)
      );
      bookNowQuestionnaire.classList.add('hidden');

      this.appendChild(bookNowQuestionnaire);

      let bookNowZones = new BookNowZones(
        function () {
          bookNowZones.classList.add('hidden');
          this.querySelector('#book-now-container').classList.remove('hidden');
        }.bind(this)
      );
      bookNowZones.classList.add('hidden');

      let bookNowSchedule = new BookNowSchedule(
        function () {
          bookNowSchedule.classList.add('hidden');
          this.querySelector('#book-now-container').classList.remove('hidden');
        }.bind(this)
      );
      bookNowSchedule.classList.add('hidden');

      this.appendChild(bookNowQuestionnaire);
      this.appendChild(bookNowZones);
      this.appendChild(bookNowSchedule);

      this.querySelector('#book-now-open-manager').addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          bookNowQuestionnaire.classList.remove('hidden');
          this.querySelector('#book-now-container').classList.add('hidden');
        }.bind(this)
      );

      this.querySelector('#book-now-service-zones').addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          bookNowZones.classList.remove('hidden');
          this.querySelector('#book-now-container').classList.add('hidden');
        }.bind(this)
      );

      this.querySelector('#book-now-service-hours').addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          bookNowSchedule.classList.remove('hidden');
          this.querySelector('#book-now-container').classList.add('hidden');
        }.bind(this)
      );
    } else {
      cancelCredentialsButton.style.display = 'none';
      editCredentialsButton.style.display = 'none';
    }

    editCredentialsButton.addEventListener('click', () => {
      this.querySelectorAll('.book-now-credentials').forEach((input) => {
        input.removeAttribute('readonly');
      });
      cancelCredentialsButton.style.display = 'inline-block';
      saveCredentialsButton.style.display = 'inline-block';
      editCredentialsButton.style.display = 'none';
    });

    cancelCredentialsButton.addEventListener('click', () => {
      this.querySelectorAll('.book-now-credentials').forEach((input) => {
        input.setAttribute('readonly', 'true');
      });
      cancelCredentialsButton.style.display = 'none';
      saveCredentialsButton.style.display = 'none';
      editCredentialsButton.style.display = 'inline-block';
    });

    saveCredentialsButton.addEventListener('click', () => {
      this.saveCredentials();
    });

    this.querySelector('#save-book-now-settings').addEventListener('click', (e) => {
      e.preventDefault();
      this.saveSettings();
    });

    const book_now_enabled = this.querySelector('#book-now-enabled');
    if (book_now_enabled) {
      book_now_enabled.addEventListener(
        'click',
        function (e) {
          this.updateBrowserButtonToggle(e.currentTarget.checked);
        }.bind(this)
      );
    }

    this.updateBrowserButtonToggle(book_now_enabled.checked);
  }

  updateBrowserButtonToggle(v) {
    const browser_button_switch = this.querySelector('#book-now-browser-button-enabled');
    if (browser_button_switch) {
      if (v) {
        browser_button_switch.removeAttribute('disabled');
      } else {
        browser_button_switch.setAttribute('disabled', true);
      }
    }
  }


  async saveCredentials() {
    if (this.validateSettings()) {
      if (!this.not_setup) {
        const confirmed = await confirmPlus(
          'Editing these credentials will delete your current Book Now settings. Are you sure you want to continue?'
        );
        if (!confirmed) {
          return;
        }
      }

      const saveCredentialsButton = /** @type {HTMLButtonElement} */ (
        this.querySelector('#save-book-now-credentials')
      );

      saveCredentialsButton.setAttribute('disabled', 'true');

      const data = {
        tenant_id: this.querySelector('#book-now-tenant-id').value,
        client_id: this.querySelector('#book-now-client-id').value,
        client_secret: this.querySelector('#book-now-client-secret').value,
      };

      try {
        const res = await fetch(`/admin/domains/${this.domain_id}/service_titan_credentials`, {
          headers: {
            'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
            'Content-type': 'application/json',
          },
          method: 'POST',
          body: JSON.stringify(data),
        });
        if (res.ok) {
          Common.notify('Book Now Credentials saved.', 'success');

          const jobTypesDataBinder = new DataBinder(
            `/admin/domains/${this.domain_id}/service_titan_job_types`,
            true
          );
          jobTypesDataBinder.fetchData();

          const businessUnitsDataBinder = new DataBinder(
            `/admin/domains/${this.domain_id}/service_titan_business_units`,
            true
          );
          businessUnitsDataBinder.fetchData();

          const crmCampaignsDataBinder = new DataBinder(
            `/admin/domains/${this.domain_id}/service_titan_campaigns`,
            true
          );
          crmCampaignsDataBinder.fetchData();

          this.connectedCallback();
        } else {
          throw new Error('Unable to save Book Now Credentials.');
        }
      } catch (error) {
        console.error(error);
        Common.notify('Unable to save Book Now Credentials.', 'error');
      } finally {
        saveCredentialsButton.removeAttribute('disabled');
      }
    }
  }

  async saveSettings() {
      this.querySelector('#save-book-now-settings').setAttribute('disabled', true);

      let data = {};

      if (!this.not_setup) {
        let branding_config = [];
        branding_config.push({
          item_name: BookNowSettings.BRANDING_NAV_COLOR,
          item_value: this.querySelector('#book-now-nav-color').value,
        });
        branding_config.push({
          item_name: BookNowSettings.BRANDING_NAV_BG_COLOR,
          item_value: this.querySelector('#book-now-nav-bg-color').value,
        });

        data.enabled = this.querySelector('#book-now-enabled').checked ? 1 : 0;
        // if book now is disabled, so is the browser button
        if (!data.enabled) {
          data.book_now_browser_button_enabled = false;
        } else {
          data.book_now_browser_button_enabled = this.querySelector(
            '#book-now-browser-button-enabled'
          ).checked
            ? 1
            : 0;
        }
        data.arrival_window_enabled = this.querySelector('#book-now-arrival-window-enabled').checked
          ? 1
          : 0;
        data.branding_config = branding_config;
        data.campaign_id = this.querySelector('#book-now-campaign-id').value;
        data.book_now_confirmation_message = this.querySelector('#book_now_confirmation').value;
      }

      let res = await fetch(`/admin/domains/${this.domain_id}/service_titan_settings`, {
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
          'Content-type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify(data),
      });

      if (!res.ok)
        // or check for response.status
        throw new Error(res.statusText);

      let response = await res.json();
      if (response.success) {
        Common.notify('Book Now Settings saved.', 'success');
        this.connectedCallback();
      } else {
        Common.notify(
          `Unable to update Book Now settings. ${response.error ? response.error : ''}`,
          'error'
        );
      }

      this.querySelector('#save-book-now-settings').removeAttribute('disabled');
  }

  validateSettings() {
    let tenant_id = this.querySelector('#book-now-tenant-id').value;
    let client_id = this.querySelector('#book-now-client-id').value;
    let client_secret = this.querySelector('#book-now-client-secret').value;

    let all_valid = true;

    if (tenant_id.length <= 0) {
      all_valid = false;
    }

    if (client_id.length <= 0) {
      all_valid = false;
    }

    if (client_secret.length <= 0) {
      all_valid = false;
    }

    return all_valid;
  }
}

BookNowSettings.BRANDING_NAV_COLOR = "NavColor"
BookNowSettings.BRANDING_NAV_BG_COLOR = "NavBgColor"

customElements.define('book-now-settings', BookNowSettings)

class BookNowCampaignsSelect extends HTMLSelectElement {
  constructor() {
    super();
    this.template = document.createElement('template');
  }

  // NOT TESTED
  requestUpdate(data){
    this.data = data;

    let options = this.data.map(campaign => `<option value="${campaign.id}">${campaign.name}</option>`).join("")
    this.template.innerHTML =`
      <option value=null>Choose</option>
      ${options}
    `
    
    Array.from(this.options).map(opt=> {
        opt.parentNode.removeChild(opt);
    });

    this.appendChild(this.template.content.cloneNode(true));
    this.value = this.getAttribute("data-selected");
    if(this.selectedOptions.length == 0) {
      this.value = "null"
    }
  }

  async connectedCallback() {
    this.data_binder = new DataBinder(`/admin/domains/${this.getAttribute("domain_id")}/service_titan_campaigns`, true);
    this.data_binder.register(this);
    if(this.data_binder.data) {
      this.requestUpdate(this.data_binder.data);
    }
  }

  disconnectedCallback(){
    this.data_binder.unregister(this);
  }
}

customElements.define('book-now-campaigns-select', BookNowCampaignsSelect, {extends: 'select'});

export class BookNowZones extends HTMLElement {
  constructor(goBack) {
    super();
    this.goBack = goBack;
  }

  async connectedCallback() {
    this.domain_id = document.querySelector("#object_id").value;

    let res = await fetch(`/admin/domains/${this.domain_id}/book_now/zones`, 
        {headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
        method: 'GET'
      });

    let zones = await res.json();

    this.innerHTML = `
      <style>
        #book-now-add-crm-zone {
          margin: 0 20px 20px 0;
        }
      </style>
      <div class="row">
        <div class="col-sm-9">
          <h3 class="pull-left"><span id="book-now-back" class="back-chevron"></span> Service Zones</h3>
          <button class="btn btn-primary btn-outline-primary pull-right" id="book-now-add-zone">Add Zone</button>
          <button class="btn btn-primary btn-outline-primary pull-right" id="book-now-add-crm-zone">Populate from CRM</button>
        </div>
      </div>
      <div id="book-now-zones-container" class="row">
      </div>
      <div class="row">
        <div class="col-sm-9">
          <button class="btn btn-primary pull-right" id="book-now-zones-save">Save</button>
        </div>
      </div>
    `

    if(zones.length > 0) {
      zones.forEach(function(zone){
        this.querySelector("#book-now-zones-container").appendChild(new BookNowZone(zone));  
      }.bind(this))
    } else {
      this.querySelector("#book-now-zones-container").appendChild(new BookNowZone());
    }

    this.querySelector("#book-now-back").addEventListener("click", function() {
      this.goBack();
    }.bind(this));

    this.querySelector("#book-now-add-zone").addEventListener("click", function(e) {
      e.preventDefault();
      this.querySelector("#book-now-zones-container").appendChild(new BookNowZone());
    }.bind(this));

    this.querySelector("#book-now-add-crm-zone").addEventListener("click", function(e) {
      e.preventDefault();
      this.addCrmZone();
    }.bind(this));

    this.querySelector("#book-now-zones-save").addEventListener("click", function(e){
      e.preventDefault();
      this.save();
    }.bind(this));
  }

  async save() {
    if(this.validate()) {
      let data = this.getData();

      let res = await fetch(`/admin/domains/${this.domain_id}/book_now/zones`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'POST',
        body: JSON.stringify(data)
      })

      if (!res.ok) // or check for response.status
          throw new Error(res.statusText);
      
      let response = await res.json();
      if(response.success) {
        this.connectedCallback();
        Common.notify('Book Now Zones saved.', 'success');
      } else {
        Common.notify(`Unable to save Book Now Zones. ${response.error ? response.error : ""}`, 'error');
      }
    }
  }

  validate() {
    let all_valid = true
    this.querySelectorAll("book-now-zone").forEach((zone) => {
      if(!zone.validate()) {
        all_valid = false;
      }
    });

    return all_valid;
  }

  getData() {
    let zones = []
    this.querySelectorAll("book-now-zone").forEach((zone) => {
      zones.push(zone.getData());
    });

    return zones;
  }

  async addCrmZone() {
    let res = await fetch(`/admin/domains/${this.domain_id}/book_now/crm/zones`);
    let json = await res.json();

    json.forEach(data => {
      let nodes = [...this.querySelectorAll('#book-now-zones-container book-now-zone')]
      let current_ids = nodes.map(elem => {
        return elem.getExternalZoneId();
      })
      nodes.forEach(elem => {
        if(elem.getExternalZoneId() == data.external_zone_id) {
          elem.setCrmData(data)
        }
      })
      let book_now_zone = new BookNowZone();
      book_now_zone.setExternalZoneId(data);

      if(current_ids.includes(book_now_zone.getExternalZoneId())) {
        return
      }
      this.querySelector("#book-now-zones-container").appendChild(book_now_zone);
      book_now_zone.setCrmData(data)
    })
  }
}

customElements.define('book-now-zones', BookNowZones)

export class BookNowZone extends HTMLElement {
  constructor(zone) {
    super();
    this.zone = zone;
    this.external_zone_id = zone ? zone.external_zone_id : null;
    this.deleted = false;
  }

  async connectedCallback() {
    this.domain_id = document.querySelector("#object_id").value;
    
    this.innerHTML = `
      <style>
        book-now-zone .form-control {margin-bottom: 10px;}
      </style>
      <div class="col-sm-8">
        <h4 class="pull-left">Zone</h4>
        <button class="btn btn-danger pull-right" id="book-now-zone-remove">Delete</button>
      </div>
      <div class="col-sm-8">
        <div class="errors-container col-sm-12"></div>
        <label>Zone Name</label>
        <input type="text" class="form-control book-now-zone-name" maxlength="30" value="${this.zone ? this.zone.zone_name : ""}"/>
        <label>Zone Zip Codes<span>(separate by commas)</span></label>
        <textarea class="form-control book-now-zone-zips">${this.zone ? this.zone.domain_service_zone_zips.map((zip_code) => {return zip_code.zip_code}).join(", ") : ""}</textarea>
      </div>
    `



    this.querySelector("#book-now-zone-remove").addEventListener("click", function(e){
      e.preventDefault();
      if(this.zone) {
        this.classList.add("hidden");
        this.deleted = true;
      } else {
        this.remove();
      }
    }.bind(this))
  }

  setCrmData(data) {
    if(!this.querySelector('.book-now-zone-name').value) {
      this.querySelector('.book-now-zone-name').value = data.name;
    }
    this.querySelector('.book-now-zone-zips').value = data.zips.join(", ");
  }

  setExternalZoneId(data) {
    this.external_zone_id = data.external_zone_id
  }

  getExternalZoneId() {
    return this.external_zone_id
  }

  validate() {
    console.log("Checking if valid");
    let errors = ""
    let all_valid = true;

    if(this.querySelector(".book-now-zone-name").value.trim().length <= 0) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                      <strong>Warning!</strong> Please provide a Zone Name.
                    </div>`;
      all_valid = false;
    }

    let zones = this.querySelector(".book-now-zone-zips").value.split(",");
    let empty = zones.filter(i => {return i != ''}).length == 0;

    zones.forEach((zip) => {
      let zip_length = zip.trim().length;
      if(!empty && zip_length < 5 || zip_length > 7) {
        errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                      <strong>Warning!</strong> Please enter valid zip codes.
                    </div>`;
      all_valid = false;
      }
    });

    if(!all_valid) {
      Common.notify(`Unable to save service zones.`, 'error');
    }
    this.querySelector('.errors-container').innerHTML = errors;

    return all_valid;
  }

  getData() {

    let new_zone_zips = [];
    let deleted_zone_zips = [];
    
    let zip_codes_data = [];
    this.querySelector(".book-now-zone-zips").value.split(",").forEach((zip) => {
      zip_codes_data.push(zip.trim());
    })
    if(this.zone) {
      this.zone.domain_service_zone_zips.forEach((zip_code) => {
        console.log(zip_codes_data)
        console.log(zip_code.zip_code)
        if(zip_codes_data.indexOf(zip_code.zip_code) < 0) {
          zip_code._delete = true;
          deleted_zone_zips.push(zip_code);
        }
      });
    }
    zip_codes_data.forEach((zip_code) => {
      if(zip_code.trim().length == 0) {
        return;
      }
      let domain_service_zone_zip_id = null;
      if(this.zone) {
        let located_zone_zip = this.zone.domain_service_zone_zips.find(existing_zip_code => existing_zip_code.zip_code == zip_code.trim())
        domain_service_zone_zip_id = located_zone_zip ? located_zone_zip.domain_service_zone_zip_id : null;
      }
      new_zone_zips.push({
        domain_service_zone_zip_id: domain_service_zone_zip_id,
        zip_code: zip_code.trim()
      });
    });

    let zip_code_data = new_zone_zips.concat(deleted_zone_zips);

    return {
      domain_service_zone_id: this.zone ? this.zone.domain_service_zone_id : null,
      zone_name: this.querySelector(".book-now-zone-name").value.trim(),
      external_zone_id: this.external_zone_id,
      zip_codes: zip_code_data,
      _delete: this.deleted
    }
  }
}

customElements.define('book-now-zone', BookNowZone)

export class BookNowSchedule extends HTMLElement {
  constructor(goBack) {
    super();
    this.goBack = goBack;
  }

  async connectedCallback() {
    this.domain_id = document.querySelector("#object_id").value;

    let res = await fetch(`/admin/domains/${this.domain_id}/book_now/schedule`, 
        {headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
        method: 'GET'
      });

    let schedule = await res.json();

    this.innerHTML = `
      <div class="col-sm-8">
        <h3 class="pull-left"><span id="book-now-back" class="back-chevron"></span> Service Hours</h3>
      </div>
      <div class="errors"></div>

      <div class="row">
        <div class="col-md-6">
           <h4 class="pull-left col-sm-4 no-gutters">Use CRM Capacity for Schedule</h4>
           <label class="switch col-sm-4" style="margin-top:10px;">
            <input type="checkbox" class="form-control switch" id="book-now-capacity-appt-enabled" ${schedule.book_now_capacity_appt_enabled ? "checked='checked'":""}>
            <span></span>
          </label>
        </div>
        <div class="col-md-6">
           <button id="book-now-populate-capacity" class="btn btn-outline-primary" style="display: ${!schedule.book_now_capacity_appt_enabled ? "none": "block"}">Populate Schedule From CRM</button>
        </div>
      </div>

      <div class="row" id="traditional-schedule">
        <div class="row" id="book-now-schedule-container">
        </div>
      </div>

      <div class="row" id="crm-schedule" style="display: ${!schedule.book_now_capacity_appt_enabled ? "none": "block"}">
        <div class="row" id="book-now-crm-schedule-container">
        </div>
      </div>
      
      <div class="row">
        <div class="col-sm-9">
          <button class="btn btn-primary pull-right save-schedule">Save</button>
        </div>
      </div>
    `

    this.querySelector("#book-now-capacity-appt-enabled").addEventListener('change', (e) => {
      if(e.target.checked){
        this.querySelector("book-now-appt-slots").style.display = 'none';
        this.querySelector("#crm-schedule").style.display = 'block';
        this.querySelector("#book-now-populate-capacity").style.display = 'block';
      } else {
        this.querySelector("book-now-appt-slots").style.display = 'block';
        this.querySelector("#crm-schedule").style.display = 'none';
        this.querySelector("#book-now-populate-capacity").style.display = 'none';
      }
    });

    this.querySelector("#book-now-populate-capacity").addEventListener("click", async function (e){
      e.preventDefault();
      if(await confirmPlus("Schedules will be pulled from the CRM replacing existing. Are you sure?")) {
        this.populateCRMSchedule();
      }
    }.bind(this))

     
    this.querySelector("#book-now-schedule-container").appendChild(new BookNowScheduleHours(schedule.site_hours));

    let traditional_slots = new BookNowScheduleApptSlot(!schedule.book_now_capacity_appt_enabled ? schedule.site_appts : [])
    traditional_slots.style.display = schedule.book_now_capacity_appt_enabled ? 'none' : 'block'
    this.querySelector("#book-now-schedule-container").appendChild(traditional_slots);
    
    if(schedule.book_now_capacity_appt_enabled) {
      this.addCRMSchedule(schedule.site_appts);
    }

    $(this).find(".holiday_date_picker").daterangepicker(
      {
        autoApply: true,
        minDate: moment().add(1,'days'),
        singleDatePicker: true
      },
      function (start) {
        this.cancellation_date = start.startOf("day").format('YYYY-MM-DD');
      }.bind(this)
    );

    this.querySelector("#book-now-back").addEventListener("click", function() {
      this.goBack();
    }.bind(this));

    this.querySelector('.save-schedule').addEventListener("click", function(e) {
      e.preventDefault();
      this.save();
    }.bind(this))
  }

  async save() {
    if(this.validate()) {
      let data = {};
      
      data.book_now_capacity_appt_enabled = this.querySelector("#book-now-capacity-appt-enabled").checked;
      data.site_hours = this.querySelector("book-now-schedule-hours").getData();
      if(!data.book_now_capacity_appt_enabled) {
        data.site_appts = this.querySelector("book-now-appt-slots").getData();
      } else {
        data.site_appts = []
        this.querySelectorAll("book-now-crm-appt-slots").forEach((crm_business_unit_slots) => {
          data.site_appts = data.site_appts.concat(crm_business_unit_slots.getData()); 
        }); 
      }

      let res = await fetch(`/admin/domains/${this.domain_id}/book_now/schedule`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'POST',
        body: JSON.stringify(data)
      })

      if (!res.ok) // or check for response.status
          throw new Error(res.statusText);
      
      let response = await res.json();
      if(response.success) {
        this.connectedCallback();
        Common.notify('Book Now Schedule saved.', 'success');
      } else {
        Common.notify(`Unable to save Book Now Schedule. ${response.error ? response.error : ""}`, 'error');
      }
    }
  }

  validate() {
    let is_valid = true;
    let errors = '';
    this.querySelector('.errors').innerHTML = '';

    if(!this.querySelector("#book-now-capacity-appt-enabled").checked) {
      if(this.querySelector('book-now-schedule-hours').validate().type.includes('day')) {
        errors += `<div class="alert alert-danger alert-dismissible" role="alert">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>Warning!</strong> Please select at least one day of the week.
        </div>`;
        is_valid = false
      }
      if(this.querySelector('book-now-appt-slots').validate().type.includes('name')) {
        errors += `<div class="alert alert-danger alert-dismissible" role="alert">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>Warning!</strong> Please enter a name for your appointment.
        </div>`;
        is_valid = false
      }
      if(this.querySelector('book-now-appt-slots').validate().type.includes('time') || this.querySelector('book-now-schedule-hours').validate().type.includes('time')) {
        errors += `<div class="alert alert-danger alert-dismissible" role="alert">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>Warning!</strong> Please enter a valid timeframe.
        </div>`;
        is_valid = false
      }
    } else {
      this.querySelectorAll('book-now-crm-appt-slots').forEach((appt_slot) => {
        if(appt_slot.validate().type.includes('name')) {
          errors += `<div class="alert alert-danger alert-dismissible" role="alert">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <strong>Warning!</strong> Please enter a name for your appointment.
          </div>`;
          is_valid = false
        }
      });
    }

    this.querySelector('.errors').innerHTML = errors;

    return is_valid;
  }

  async populateCRMSchedule() {
    this.querySelector("#book-now-crm-schedule-container").innerHTML = "Loading...";
    let res = await fetch(`/admin/domains/${this.domain_id}/book_now/schedule/crm`, 
        {headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
        method: 'GET'
      });

    let timeslots = await res.json();
    this.addCRMSchedule(timeslots);
  }

  addCRMSchedule(timeslots) {

    let organized_by_business_units = {};
    timeslots.forEach((timeslot) => {
      let business_unit_id = timeslot.business_unit_id;
      if(organized_by_business_units[business_unit_id]) {
        organized_by_business_units[business_unit_id].push(timeslot);
      } else {
        organized_by_business_units[business_unit_id] = [timeslot];
      }
    })
    this.querySelector("#book-now-crm-schedule-container").innerHTML = "";
    Object.keys(organized_by_business_units).forEach((business_unit_id) => {
      this.querySelector("#book-now-crm-schedule-container").appendChild(new BookNowCrmApptSlots(organized_by_business_units[business_unit_id]));
    })
  }
}

customElements.define('book-now-schedule', BookNowSchedule)

export class BookNowScheduleHours extends HTMLElement {
  constructor(site_hours) {
    super();
    this.site_hours = site_hours;
  }

  async connectedCallback() {
    this.domain_id = document.querySelector("#object_id").value;

    
    this.innerHTML = `
      <style>
        book-now-schedule table {
          width: 100%;
          text-align: center;
          margin: 3px
        }
        book-now-schedule table th{
          text-align: center;
          font-size: 14px;
        }
        book-now-schedule table td{
          padding: 5px
        }
      </style>
      <div class="row">
        <div class="col-sm-9" style="margin-top: 20px">
          <h3 class="pull-left">Business Hours</h4>
          <button class="btn btn-outline-primary pull-right" id="book-now-hours-add">Add Hours</button>
        </div>
        <div class="col-sm-9">
          <table>
            <thead>
              <th>Sun</th>
              <th>Mon</th>
              <th>Tue</th>
              <th>Wed</th>
              <th>Thu</th>
              <th>Fri</th>
              <th>Sat</th>
              <th>Start</th>
              <th>End</th>
              <th>Delete</th>
            </thead>
            <tbody>
              
            <tbody>
          </table>
        </div>
      </div>
    `

    this.querySelector("#book-now-hours-add").addEventListener("click", function(e) {
      e.preventDefault();
      this.querySelector("tbody").appendChild(this.generateSiteHours());
    }.bind(this))

    if(this.site_hours && this.site_hours.length > 0) {
      this.site_hours.forEach(function(site_hour_data) {
        this.querySelector("tbody").appendChild(this.generateSiteHours(site_hour_data));
      }.bind(this));
    } else {
      this.querySelector("tbody").appendChild(this.generateSiteHours());
    }
  }

  generateSiteHours(site_hour_data) {
    let tr = document.createElement('tr');
    console.log("site_hour_data")
    tr.innerHTML = `
        <td><input class="book-now-schedule-sunday" type="checkbox" value="1" ${site_hour_data && (site_hour_data.days_of_week & 1) > 0 ? "checked": ""}/></td>
        <td><input class="book-now-schedule-monday" type="checkbox" value="2" ${site_hour_data && (site_hour_data.days_of_week & 2) > 0 ? "checked": ""}/></td>
        <td><input class="book-now-schedule-tuesday" type="checkbox" value="4" ${site_hour_data && (site_hour_data.days_of_week & 4) > 0 ? "checked": ""}/></td>
        <td><input class="book-now-schedule-wednesday" type="checkbox" value="8" ${site_hour_data && (site_hour_data.days_of_week & 8) > 0 ? "checked": ""}/></td>
        <td><input class="book-now-schedule-thursday" type="checkbox" value="16" ${site_hour_data && (site_hour_data.days_of_week & 16) > 0 ? "checked": ""}/></td>
        <td><input class="book-now-schedule-friday" type="checkbox" value="32" ${site_hour_data && (site_hour_data.days_of_week & 32) > 0 ? "checked": ""}/></td>
        <td><input class="book-now-schedule-saturday" type="checkbox" value="64" ${site_hour_data && (site_hour_data.days_of_week & 64) > 0 ? "checked": ""}/></td>
        <td>
          <book-now-schedule-hours-time class="book-bow-hours-start" data-time="${site_hour_data ? site_hour_data.start_time : ""}"></book-now-schedule-hours-time>
        </td>
        <td>
          <book-now-schedule-hours-time class="book-bow-hours-end" data-time="${site_hour_data ? site_hour_data.end_time : ""}"></book-now-schedule-hours-time>
        </td>
        <td><button class="btn btn-danger">Delete</button></td>
      `;

    if(site_hour_data) {
      tr.dataset.site_hours_id =Number(site_hour_data.site_hours_id);
    }

    tr.querySelector("button").addEventListener("click", function(e) {
      e.preventDefault();
      if(tr.dataset.site_hours_id != "") {
        tr.dataset.deleted = true;
        tr.classList.add("hidden");
      } else {
        tr.remove();
      }
    });

    return tr;
  }

  getData() {
    let data = [];
    this.querySelectorAll("tbody tr").forEach(function(hours) {
      data.push(this.getSiteHoursData(hours));
    }.bind(this))
    return data;
  }

  getSiteHoursData(hours) {
    let site_hours_id = hours.dataset.site_hours_id != null ? hours.dataset.site_hours_id : null;
    let days_of_week = 0
    hours.querySelectorAll("input[type=checkbox]").forEach((day) => {
      days_of_week += day.checked ? Number(day.value) : 0
    })
    let start_time = hours.querySelector(".book-bow-hours-start").getTime();
    let end_time = hours.querySelector(".book-bow-hours-end").getTime();

    return {
      site_hours_id: site_hours_id,
      days_of_week: days_of_week,
      start_time: start_time,
      end_time: end_time,
      _delete: hours.dataset.deleted == "true" ? true : false
    }
  }

  validate() {
    let validation = {is_valid: true, type: []};

    this.querySelectorAll("tbody tr").forEach(hours => {
      if(!hours.querySelector('input[type="checkbox"]:checked')) {
        validation.is_valid = false;
        validation.type.push('day');
      }
      if(Number(hours.querySelector('.book-bow-hours-start').getTime()) >= Number(hours.querySelector('.book-bow-hours-end').getTime())){
        hours.querySelectorAll('select').forEach(select => {
          select.classList.add('error');
        })

        validation.is_valid = false;
        validation.type.push('time');
      }
    })

    return validation
  }
}

customElements.define('book-now-schedule-hours', BookNowScheduleHours)

export class BookNowScheduleHoursTime extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    this.innerHTML = `
        <select name="book-now-hour" class="form-control pull-left" style="width: 50%; margin-right: 10%">
          <option checked value="00">12 AM</option>
          <option value="01">1 AM</option>
          <option value="02">2 AM</option>
          <option value="03">3 AM</option>
          <option value="04">4 AM</option>
          <option value="05">5 AM</option>
          <option value="06">6 AM</option>
          <option value="07">7 AM</option>
          <option value="08">8 AM</option>
          <option value="09">9 AM</option>
          <option value="10">10 AM</option>
          <option value="11">11 AM</option>
          <option value="12">12 PM</option>
          <option value="13">1 PM</option>
          <option value="14">2 PM</option>
          <option value="15">3 PM</option>
          <option value="16">4 PM</option>
          <option value="17">5 PM</option>
          <option value="18">6 PM</option>
          <option value="19">7 PM</option>
          <option value="20">8 PM</option>
          <option value="21">9 PM</option>
          <option value="22">10 PM</option>
          <option value="23">11 PM</option>
        </select>
        <select name="book-now-minute" class="form-control pull-left" style="width: 40%">
          <option>00</option>
          <option>05</option>
          <option>10</option>
          <option>15</option>
          <option>20</option>
          <option>25</option>
          <option>30</option>
          <option>35</option>
          <option>40</option>
          <option>45</option>
          <option>50</option>
          <option>55</option>
        </select>
    `

    let time = this.dataset.time;
    if(time.length == 4) {
      this.querySelector("select[name=book-now-hour]").value = time.slice(0,2);
      this.querySelector("select[name=book-now-minute]").value = time.slice(2,4);
    }
  }

  getTime() {
    return this.querySelector("select[name=book-now-hour]").value + this.querySelector("select[name=book-now-minute]").value;
  }
}

customElements.define('book-now-schedule-hours-time', BookNowScheduleHoursTime)

export class BookNowScheduleApptSlot extends HTMLElement {
  constructor(appt_slots) {
    super();
    this.appt_slots = appt_slots;
  }

  async connectedCallback() {
    this.domain_id = document.querySelector("#object_id").value;

    
    this.innerHTML = `
      <style>
        book-now-appt-slots table {
          width: 100%;
          text-align: center;
          margin: 3px
        }
        book-now-appt-slots table th{
          text-align: center;
          font-size: 14px;
        }
        book-now-appt-slots table td{
          padding: 5px
        }
      </style>
      <div class="row">
        <div class="col-sm-9" style="margin-top: 20px">
          <h3 class="pull-left">Book Now Appointment Slots</h4>
          <button class="btn btn-outline-primary pull-right" id="book-now-appt-slots-add">Add Appointment Slot</button>
        </div>
        <div class="col-sm-9">
          <table>
            <thead>
              <th>Name</th>
              <th>Start Time</th>
              <th>End Time</th>
              <th>Delete</th>
            </thead>
            <tbody>
              
            <tbody>
          </table>
        </div>
      </div>
    `

    this.querySelector("#book-now-appt-slots-add").addEventListener("click", function(e) {
      e.preventDefault();
      this.querySelector("tbody").appendChild(this.generateApptSlot());
    }.bind(this))

    if(this.appt_slots && this.appt_slots.length > 0) {
      this.appt_slots.forEach(function(appt_slot_data) {
        this.querySelector("tbody").appendChild(this.generateApptSlot(appt_slot_data));
      }.bind(this));
    } else {
      this.querySelector("tbody").appendChild(this.generateApptSlot());
    }
  }

  generateApptSlot(appt_slot_data) {
    let tr = document.createElement('tr');
    tr.innerHTML = `
        <td><input class="form-control" type="text" value="${appt_slot_data ? appt_slot_data.name : ""}"/></td>
        <td>
          <book-now-schedule-hours-time class="book-bow-appt-slot-start" data-time="${appt_slot_data ? appt_slot_data.start_time : ""}"></book-now-schedule-hours-time>
        </td>
        <td>
          <book-now-schedule-hours-time class="book-bow-appt-slot-end" data-time="${appt_slot_data ? appt_slot_data.end_time : ""}"></book-now-schedule-hours-time>
        </td>
        <td><button class="btn btn-danger">Delete</button></td>
      `;

    if(appt_slot_data) {
      tr.dataset.site_appointment_slot_id =Number(appt_slot_data.site_appointment_slot_id);
    }

    tr.querySelector("button").addEventListener("click", function(e) {
      e.preventDefault();
      if(tr.dataset.site_appointment_slot_id) {
        tr.dataset.deleted = true;
        tr.classList.add("hidden");
      } else {
        tr.remove();
      }
    });

    return tr;
  }

  getData() {
    let data = [];
    this.querySelectorAll("tbody tr").forEach(function(appt_slot) {
      data.push(this.getSiteApptSlotData(appt_slot));
    }.bind(this))
    return data;
  }

  getSiteApptSlotData(appt_slot) {
    let site_appointment_slot_id = appt_slot.dataset.site_appointment_slot_id != null ? appt_slot.dataset.site_appointment_slot_id : null;
    
    let start_time = appt_slot.querySelector(".book-bow-appt-slot-start").getTime();
    let end_time = appt_slot.querySelector(".book-bow-appt-slot-end").getTime();

    return {
      site_appointment_slot_id: site_appointment_slot_id,
      name: appt_slot.querySelector("input[type=text]").value,
      start_time: start_time,
      end_time: end_time,
      _delete: appt_slot.dataset.deleted == "true" ? true : false
    }
  }

  validate() {
    let validation = {is_valid: true, type: []};
    this.querySelectorAll('tbody tr').forEach(row => {
      row.querySelector('input').classList.remove('error');
      row.querySelectorAll('select').forEach(select => {
        select.classList.remove('error');
      })

      // Validate appointment name
      if(!row.querySelector('input').value) {
        row.querySelector('input').classList.add('error');
        validation.is_valid = false;
        validation.type.push('name');
      }

      // Validate appointment time
      if(Number(row.querySelector('.book-bow-appt-slot-start').getTime()) >= Number(row.querySelector('.book-bow-appt-slot-end').getTime())){
        row.querySelectorAll('select').forEach(select => {
          select.classList.add('error');
        })

        validation.is_valid = false;
        validation.type.push('time');
      }
    })

    return validation
  }
}

customElements.define('book-now-appt-slots', BookNowScheduleApptSlot)

export class BookNowCrmApptSlots extends HTMLElement {
  constructor(appt_slots) {
    super();
    this.appt_slots = appt_slots;
  }

  async connectedCallback() {
    this.domain_id = document.querySelector("#object_id").value;

    
    this.innerHTML = `
      <div class="row">
        <div class="col-sm-9" style="margin-top: 20px">
          <h3 class="pull-left">${this.appt_slots[0].business_unit_name} Appointment Slots</h4>
        </div>
        <div class="col-sm-9">
          <table style="width: 100%">
            <thead>
              <th>Name</th>
              <th>Start Time</th>
              <th>End Time</th>
              <th></th>
            </thead>
            <tbody>
              
            <tbody>
          </table>
        </div>
      </div>
    `

    if(this.appt_slots && this.appt_slots.length > 0) {
      this.appt_slots.forEach(function(appt_slot_data) {
        this.querySelector("tbody").appendChild(this.generateApptSlot(appt_slot_data));
      }.bind(this));
    } else {
      this.querySelector("tbody").appendChild(this.generateApptSlot());
    }
  }

  delete(row) {
    if(this.querySelectorAll("tbody tr:not(.hidden)").length == 1) {
      confirmPlus("You are required to have at least one timeslot.")
      return;
    }
    if(row.dataset.site_appointment_slot_id > 0) {
      row.dataset.deleted = true;
      row.classList.add("hidden");
    } else {
      row.remove();
    }
  }

  generateApptSlot(appt_slot_data) {
    let tr = document.createElement('tr');
    tr.innerHTML = `
        <td><input class="form-control" type="text" value="${appt_slot_data ? appt_slot_data.name : ""}"/></td>
        <td>
          ${appt_slot_data.start_time}
        </td>
        <td data-end>
          ${appt_slot_data.end_time}
        </td>
        <td><button class="btn btn-outline-danger">Remove</button></td>
      `;

    if(appt_slot_data) {
      tr.dataset.site_appointment_slot_id =Number(appt_slot_data.site_appointment_slot_id);
      tr.dataset.start_time = appt_slot_data.start_time;
      tr.dataset.end_time = appt_slot_data.end_time;
      tr.dataset.business_unit_id = appt_slot_data.business_unit_id;
    }

    tr.querySelector("button").addEventListener("click", (e) => {
      e.preventDefault();
      this.delete(tr)
    });

    return tr;
  }

  getData() {
    let data = [];
    this.querySelectorAll("tbody tr").forEach(function(appt_slot) {
      data.push(this.getSiteApptSlotData(appt_slot));
    }.bind(this))
    return data;
  }

  getSiteApptSlotData(appt_slot) {
    let site_appointment_slot_id = appt_slot.dataset.site_appointment_slot_id != null ? appt_slot.dataset.site_appointment_slot_id : null;
    
    return {
      site_appointment_slot_id: site_appointment_slot_id,
      name: appt_slot.querySelector("input[type=text]").value,
      start_time: appt_slot.dataset.start_time,
      end_time: appt_slot.dataset.end_time,
      business_unit_id: appt_slot.dataset.business_unit_id,
      _delete: appt_slot.dataset.deleted == "true" ? true : false
    }
  }

  validate() {
    let validation = {is_valid: true, type: []};
    this.querySelectorAll('tbody tr').forEach(row => {
      // Validate appointment name
      if(!row.querySelector('input').value) {
        row.querySelector('input').classList.add('error');
        validation.is_valid = false;
        validation.type.push('name');
      }
    })

    return validation;
  }
}

customElements.define('book-now-crm-appt-slots', BookNowCrmApptSlots)

